import { useMemo } from 'react';
import { useArtifactLinkQuery, useArtifactsQuery } from '~/queries';
import { LOG_ARTIFACT_HTML_FILE_NAME } from '~/constants';

export const useArtifactLink = (
  processId?: string,
  processRunId?: string,
  activityRunId?: string,
) => {
  const isEnabled = !!(processId && processRunId && activityRunId);

  const { data: artifacts = [], isLoading: isArtifactsLoading } = useArtifactsQuery(
    {
      processId: processId as string,
      processRunId: processRunId as string,
      activityRunId: activityRunId as string,
    },
    {
      select: (data = []) => data.filter((item) => item.fileName === LOG_ARTIFACT_HTML_FILE_NAME),
      enabled: isEnabled,
    },
  );

  const artifactId = artifacts[0]?.id;
  const { data: artifactLink, isLoading: isArtifactLinkLoading } = useArtifactLinkQuery(
    {
      processId: processId as string,
      processRunId: processRunId as string,
      activityRunId: activityRunId as string,
      artifactId,
      artifactName: LOG_ARTIFACT_HTML_FILE_NAME,
    },
    {
      enabled: !!artifactId,
      refetchOnMount: true,
    },
  );

  const isLoading = isEnabled && (isArtifactsLoading || (!!artifactId && isArtifactLinkLoading));
  const data = useMemo(
    () => ({
      data: artifactLink,
      isLoading,
    }),
    [artifactLink, isLoading],
  );

  return data;
};
